export default "/assets/images/critter-cuddler3.png?a7ec28c6d9b4034ae6c90c4b9e116ebb";